import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AdminFeatureAccessSettingsAction } from '../../domains/adminFeatureAccessSettings/actions.types';

import { AdminFeatureAccessSettingsLifecycle } from './types';

const initialState: AdminFeatureAccessSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<AdminFeatureAccessSettingsLifecycle, AdminFeatureAccessSettingsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'ADMIN_FEATURE_ACCESS_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'ADMIN_FEATURE_ACCESS_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'ADMIN_FEATURE_ACCESS_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
